import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import { Helmet } from "react-helmet-async";
import EChallanPartner from "../../../components/desktop/e-challan-partner";
import { useHistory } from "react-router-dom";
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";

const EChallanPartnerContainer = () => {
    const history = useHistory();
    return (
        <ErrorHandler>
            <Helmet>
                <meta name="ROBOTS" content="NOINDEX,NOFOLLOW" />
            </Helmet>
            <EChallanPartner history={history} />
        </ErrorHandler>
    );
};
export default withReducer(injectable)(() => ({}), dispatch => ({dispatch}))(
    withLayout(
        EChallanPartnerContainer,
        true,
        true,
        false,
        false
    )
);

